/**
 * A deep copy of the given object. Uses JSON.parse(JSON.stringify(object)).
 */
const jsonDeepCopy = (object) => {
  return JSON.parse(JSON.stringify(object));
}

export { jsonDeepCopy };
